"use client";
import React from "react";
import { Button } from "@/app/(components)/Basic/Button";
import { ArtOrderFull } from "@/api/art-order/types";
import useInfiniteArtOrderOffers from "../../../ArtOrder/hooks/useInfiniteArtOrderOffers";
import { ArtOrderPostComment } from "../../Comment/ArtOrderPost";

export interface Props {
  artOrder: ArtOrderFull;
}

export default function ArtOrderPostCommentsList({ artOrder }: Props) {
  const { artOrderOffers, hasNextPage, fetchNextPage } =
    useInfiniteArtOrderOffers(artOrder.id);

  return (
    <>
      {artOrderOffers?.length ? (
        <ul className="mt-4 gap-4 md:mt-6 flex flex-col md:gap-6">
          {artOrderOffers.map((artOrderOffer) => (
            <ArtOrderPostComment
              key={artOrderOffer.id}
              artOrderOffer={artOrderOffer}
              paymentErc20TokenAddress={artOrder.budgetPaymentERC20TokenAddress}
            />
          ))}
        </ul>
      ) : null}
      {hasNextPage ? (
        <div className="flex justify-center">
          <Button native className="text-red " onClick={() => fetchNextPage()}>
            View more
          </Button>
        </div>
      ) : null}
    </>
  );
}
